// Copyright (c) Docugami, Inc. All rights reserved.

import { KeyboardAccelerators } from "components/shell/utils/KeyboardAccelerators";
import { useEffect, useRef } from "react"

/**
 * Hook for utilizing the key press handling provided by KeyboardAccelerators. Maintains
 * the registration for a given key, updates the callback, etc.
 * @param keyName The name of the key to register for, e.g. 'Escape'
 * @param callback The callback to trigger when the press occurs
 */
export const useKeyPressHandler = (keyName: string | undefined, callback?: () => void) => {
    const callbackRef = useRef(callback);

    useEffect(() => {
        callbackRef.current = callback;
    }, [callback]);

    useEffect(() => {
        function execute() {
            callbackRef.current?.();
        }

        if (!!keyName) {
            const currentKey = keyName;
            const token = KeyboardAccelerators.add(currentKey, execute);
            return () => KeyboardAccelerators.remove(currentKey, token);
        }
    }, [keyName]);
}
